module.exports = __webpack_public_path__ + "static/img/struct3.401be54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/struct3.png
// module id = +2DJ
// module chunks = 1